import React from 'react';
import WordAnnotateForm from './WordAnnotateForm';
import { formatTime } from './momentTime';
import Tooltip from '../Tooltip';
import Icon from '../Icon';
import './AddWordTo.css';

/** The "+" that opens an AddWordTo form; `what` names its target. */
export function AddWordButton({ what, onClick, disabled = false }) {
  return (
    <Tooltip label={`Add a word to ${what}`}>
      <button type="button" className="icon-btn icon-btn--sm add-word-btn" onClick={onClick}
        disabled={disabled} aria-label={`Add an annotation to ${what}`}>
        <Icon name="plus" size={16} />
      </button>
    </Tooltip>
  );
}

/** "the subtitle at 0:10.0", or "the words at 0:02.0" for loose ones. */
export const targetName = (target) => (target.subtitle
  ? `the subtitle at ${formatTime(target.start)}`
  : `the words at ${formatTime(target.start)}`);

/**
 * AddWordTo — annotate another word of an existing subtitle, or next to
 * existing annotations (Requirement 57). The word takes the target's time
 * window, so it joins that subtitle's bunch (aligned with it). The form
 * stays open for more words until closed.
 *
 * Props:
 *   target — { start, end, subtitle } (subtitle: true for a subtitle's
 *            window; the times are fixed when the form opens)
 *   videoId, language, yasna, yasnaError
 *   request — optional { text, n }: annotate this word straight away
 *   onSaved(annotation), onClose()
 *   idSuffix — keeps the field's id unique on the page
 */
function AddWordTo({ target, videoId, language, yasna, yasnaError, onSaved, onClose, idSuffix, request }) {
  const what = targetName(target);
  return (
    <div className="add-word-to" role="group" aria-label={`Add a word to ${what}`}>
      <div className="add-word-to-head">
        <span className="add-word-to-title">Add a word to {what}</span>
        <Tooltip label="Close">
          <button type="button" className="icon-btn icon-btn--sm" onClick={onClose}
            aria-label={`Stop adding words to ${what}`}>
            <Icon name="x" size={14} />
          </button>
        </Tooltip>
      </div>
      <WordAnnotateForm
        videoId={videoId}
        language={language}
        yasna={yasna}
        yasnaError={yasnaError}
        start={target.start}
        end={target.end}
        onSaved={onSaved}
        label="Word or phrase"
        inputId={`add-word-${idSuffix}`}
        placeholder="e.g. se rendre compte"
        request={request}
      />
    </div>
  );
}

export default AddWordTo;
